import { render, staticRenderFns } from "./PcPcm.vue?vue&type=template&id=ed8a924c&"
import script from "./PcPcm.vue?vue&type=script&lang=js&"
export * from "./PcPcm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports